module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "frame-17-2.3151b1fc.svg";